import type { ComponentProps, FC, PropsWithChildren } from 'react'

import { Transition, Disclosure as UIDisclosure } from '@headlessui/react'
import ChevronDownIcon from 'mdi-react/ChevronDownIcon'
import { twJoin, twMerge } from 'tailwind-merge'
export { Transition } from '@headlessui/react'
export const Disclosure = ({ children, ...props }: ComponentProps<typeof UIDisclosure>) => (
  <UIDisclosure {...props}>{children}</UIDisclosure>
)

export const DisclosureButton: FC<PropsWithChildren<{ isOpen?: boolean; className?: string }>> = ({
  children,
  isOpen,
  className,
  ...props
}) => (
  <UIDisclosure.Button
    className={twMerge(
      'flex w-full cursor-pointer justify-between rounded-lg border-none bg-transparent px-1 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-zinc-500 focus-visible:ring-opacity-75',
      className
    )}
    {...props}
  >
    <span className="w-full">{children}</span>
    <ChevronDownIcon
      className={twJoin('h-5 w-5 text-zinc-500', isOpen && 'rotate-180 transform')}
    />
  </UIDisclosure.Button>
)

export const DisclosurePanel: FC<PropsWithChildren<{ isOpen?: boolean; className?: string }>> = ({
  children,
  className,
  ...props
}) => (
  <Transition
    enter="transition ease duration-500 transform"
    enterFrom="opacity-0 -translate-y-6"
    enterTo="opacity-100 translate-y-0"
    leave="transition ease duration-300 transform"
    leaveFrom="opacity-100 translate-y-0"
    leaveTo="opacity-0 -translate-y-6"
  >
    <UIDisclosure.Panel className={twMerge('px-4 pb-2 pt-4', className)} {...props}>
      {children}
    </UIDisclosure.Panel>
  </Transition>
)

Disclosure.Button = DisclosureButton
Disclosure.Panel = DisclosurePanel
